import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ScripDetailUseCase extends BaseUseCase {
    constructor(commonRepository) {
        super();
        this.commonRepository = commonRepository;
    }
    async fetchResult(reqData) {
        return await this.commonRepository.getScripDetailData(reqData);
    }
}
export default ScripDetailUseCase;
